export const HistoryFieldLabels: Record<string, string> = {
  name: 'Název projektu',
  holder: 'Název nositele projektu',
  holderIc: 'IČ držitele',
  holderLegalForm: 'Právní forma držitele',
  type: 'Typ projektu',
  developmentState: 'Stav projektu',
  guarantor: 'Garant',
  contactPerson: 'Kontaktní osoba',
  contactEmails: 'Kontaktní emaily',
  briefDescription: 'Stručný popis projektu',
  eventNumber: 'Číslo akce',
  partners: 'Spolupracující subjekt',
  realizationPlace: 'Místo realizace',
  initiative: 'OP / iniciativa',
  actionPlan: 'Akční plán',
  implementationStart: 'Zahájení realizace',
  implementationEnd: 'Ukončení realizace',
  implementationLength: 'Délka realizace (měsíce)',
  financialEnd: 'Finanční ukončení projektu',
  sustainabilityPeriodStart: 'Začátek udržitelnosti',
  sustainabilityPeriodEnd: 'Konec udržitelnosti',
  territorialDecision: 'Územní rozhodnutí',
  buildingPermit: 'Stavební povolení',
  totalEstimatedCosts: 'Celkové náklady (Kč)',
  preparationCosts: 'Náklady na přípravu (Kč)',
  implementationCosts: 'Náklady na realizaci (Kč)',
  fundingMainSource: 'Hlavní zdroj financování',
  notes: 'Poznámky',
  keyWord: 'Klíčové slovo',
  projectPreparationApproval: 'Schválení projektové přípravy',
  projectPreparationResolution: 'Usnesení schválení projektové přípravy',
  otherTypeApproval: 'Schválení ostatní/jiného typu',
  otherTypeResolution: 'Usnesení související s projektem',
  financialApproval: 'Schválení závazného finančního příslibu',
  financialApprovalResolution: 'Usnesení závazného finančního příslibu',
  territorialDimension: 'Územní dimenze',
  investmentPriority: 'Investiční priorita',
  priorityAxis: 'Prioritní osa',
  operationalProgram: 'Operační program',
  resultQuantification: 'Kvantifikace výsledku',
  result: 'Výsledek/ výstup projektu',
  totalCosts: 'Celkové náklady dle finančního příslibu',
  manager: 'Vedoucí projektu',
  ownResources: 'Vlastní zdroje (způsobilé výdaje) %',
  ownResourcesIneligibleAmount: 'Vlastní zdroje (nezpůsobilé výdaje) (Kč)',
  stateBudget: 'Státní rozpočet %',
  european: 'Evropská %'
};
